import"./chunk-PXDN3KFO.js";var s=e=>e.endsWith(`.${process.env.NEXT_PUBLIC_ROOT_DOMAIN}`)?e.replace(`.${process.env.NEXT_PUBLIC_ROOT_DOMAIN}`,""):null;export{s as getSubdomain};
